import Keycloak from 'keycloak-js';
import store from '../store';
import axios from 'axios';
export const REFRESH_TOKEN_KEY = "keycloakRefreshToken";

const instance = axios.create({
  baseURL: process.env.VUE_APP_AUTH_API_URL,
});

class KeycloakService {
  constructor() {
    this.kc = new Keycloak({
      url: process.env.VUE_APP_KEYCLOAK_URL,
      realm: process.env.VUE_APP_KEYCLOAK_REALM,
      clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
    });
  }

  async initKeycloak() {
    return await this.kc.init({
      checkLoginIframe: false,
      redirectUri: process.env.VUE_APP_ADMIN_URL,
      enableLogging: true,
      pkceMethod: 'S256',
      flow: 'standard',
    }).then((auth) => {
      if (!auth) {
        // this.redirectToLogin();
        this.doLogin();
        return false;
      }
      return true;
    }).catch(() => {
      console.error("Authentication Failure");
      return false;
    });
  }

  doLogin() {
    return this.kc.login();
  }
  

  async doLogout() {
    console.log('Initiating logout process...');
    const postLogoutRedirectUri = process.env.VUE_APP_ADMIN_URL + "login";
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

    if (refreshToken) {
      console.log('Refresh token found. Attempting logout via backend API...');
      try {
        const backendLogoutUrl = '/keycloakAuth/logout';
        const response = await instance.post(backendLogoutUrl, {
          refresh_token: refreshToken
        });

        if (response.data && response.data.flag === true) {
          console.log('Backend logout successful. Redirecting...');
          window.location.href = postLogoutRedirectUri;
          return;
        } else {
          console.warn('Backend logout API call succeeded but reported failure:', response.data);
        }
      } catch (error) {
        console.error('Error calling backend logout API:', error.response ? error.response.data : error.message);
      }
    }
    
    console.log('Falling back to frontend Keycloak redirect logout.');
    const keycloakLogoutUrlBase = `${process.env.VUE_APP_KEYCLOAK_URL}realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/logout`;
    const clientId = process.env.VUE_APP_KEYCLOAK_CLIENT_ID;
    const frontendLogoutUrl = `${keycloakLogoutUrlBase}?client_id=${clientId}&post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`;
    
    window.location.href = frontendLogoutUrl;
  }

  getToken() {
    return this.kc.token;
  }

  getUserInfo(userProperty) {
    return this.kc.tokenParsed?.[userProperty] || null;
  }

  getIsAuthenticated() {
    return this.kc.authenticated;
  }

  refreshAccessToken(sec) {
    return this.kc.updateToken(sec);
  }

  async redirectToLogin() {


    // https://qa.vgos.org/realms/ampersand-internal-qa/protocol/openid-connect/auth?client_id=test&redirect_uri=https%3A%2F%2Fsmart-staff-selection-dev.web.app%2F%23%2Fvgos-internal&state=a0aa8103-8a9d-4d7b-8534-efd4de0afeb5&response_mode=query&response_type=code&scope=openid&nonce=68a60904-41fb-457d-942c-2cb76f5edafe&code_challenge=RsHAQcSxv9YMesvrkJRHFQWlhA7ozsuQe5kg160Iqh4&code_challenge_method=S256
    const redirectUri = process.env.VUE_APP_ADMIN_URL;
    const codeVerifier = this.generateRandomString();
     // Function to generate a random string

    console.log('Setting codeVerifier in sessionStorage:', codeVerifier);
    store.dispatch('setCodeVerifier', codeVerifier)
   
    // sessionStorage.setItem('pkce_code_verifier', codeVerifier); // Save for later use in backend
    console.log('code verifier in login',codeVerifier)
    const codeChallenge = await this.generateCodeChallenge(codeVerifier); // 

    // const keycloakLoginUrl = `${process.env.VUE_APP_KEYCLOAK_URL}/realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/auth` +
    // `?client_id=${process.env.VUE_APP_KEYCLOAK_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code`;
    
    const keycloakLoginUrl = `${process.env.VUE_APP_KEYCLOAK_URL}/realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/auth` +
    `?client_id=${encodeURIComponent(process.env.VUE_APP_KEYCLOAK_CLIENT_ID)}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&response_type=code` +
    `&scope=openid` +
    `&code_challenge=${encodeURIComponent(codeChallenge)}` +
    `&code_challenge_method=S256`; 
    
    window.location.href = keycloakLoginUrl;
  }

  generateRandomString(length = 43) {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    let text = '';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  
  async generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest('SHA-256', data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  // Function to generate code verifier and code challenge
  
  
}

const keycloakService = new KeycloakService();
export default keycloakService;